import styled, { css } from "styled-components";

type Variant = "primary" | "outline";

const variantStyles = ($variant: Variant = "primary") => {
    switch ($variant) {
        case "outline": return css`
            background-color: transparent;
            color: var(--color-text);
            border: 1px solid var(--color-border);
            &:hover { border-color: var(--color-accent); }
        `;
        default: return css`
            background-color: var(--color-accent);
            color: #0c1a0b;
            border: none;
            &:hover { background-color: var(--color-accent-hover); }
        `;
    }
};

export const Container = styled.div`
    display: contents;
`;

export const Button = styled.button<{ $variant?: Variant }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 2.6rem;
    max-width: 22rem;
    width: 100%;
    margin-top: 1rem;
    border-radius: 0.4rem;
    cursor: pointer;
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 0.95rem;
    text-decoration: none;
    transition: background-color 0.15s ease, border-color 0.15s ease;

    ${({ $variant }) => variantStyles($variant)}

    &:disabled {
        background-color: var(--color-surface-alt) !important;
        color: var(--color-text-muted) !important;
        border: none !important;
        cursor: not-allowed;
    }
`;
